import { t } from "ttag";

import { ExternalLink } from "metabase/common/components/ExternalLink";
import { useDocsUrl } from "metabase/common/hooks";
import { ActionIcon, Icon, Tooltip } from "metabase/ui";

export const TenantsDocsButton = () => {
  // eslint-disable-next-line metabase/no-unconditional-metabase-links-render -- we can always show links in admin panels, showMetabaseLinks doesn't apply
  const { url } = useDocsUrl("embedding/tenants");

  if (!url) {
    return null;
  }

  return (
    // Renders the ActionIcon itself as the anchor (via `component`) rather
    // than nesting a real <button> inside a real <a> — the two elements
    // were previously separate tab stops for what reads as a single "view
    // docs" control (WCAG 2.1.1/2.4.3). ExternalLink still supplies the
    // real anchor's target/rel/title and new-tab warning, unchanged.
    <Tooltip label={t`View documentation`}>
      <ActionIcon
        component={ExternalLink}
        href={url}
        size="lg"
        variant="outline"
        c="text-primary"
        bd="1px solid var(--mb-color-border-neutral)"
      >
        <Icon name="reference" />
      </ActionIcon>
    </Tooltip>
  );
};
